import { useTypedSelector } from "hooks";
import { selectIsConsumersLoading } from "features/consumers/selectors";
import { useConsumersActions } from "features/consumers/actions";
import { FilterVariant, date } from "consts/filters";
import useCellProps from "./useCellProps";
import useFiltersProps from "./useFiltersProps";
import { MenuItem, filters } from "consts/consumers";
import { useConsumerContext } from "ui/organizms/Consumers/ConsumerProvider";

export default function useConsumerTable() {
    const isConsumersLoading = useTypedSelector(selectIsConsumersLoading(MenuItem.All));

    const { selectionModel, setSelectionModel } = useConsumerContext();

    const CellProps = useCellProps();

    const FiltersProps = useFiltersProps();

    const {
        getConsumers,
        downloadCsv
    } = useConsumersActions();

    const consumerFilters = filters.get(MenuItem.All)!;

    const filterTypes = new Map<FilterVariant, string[]>([
        [FilterVariant.Text, consumerFilters[FilterVariant.Text]!],
        [FilterVariant.DateRange, date],
        [FilterVariant.MultiOption, consumerFilters[FilterVariant.MultiOption]!],
        [FilterVariant.SingleOption, consumerFilters[FilterVariant.SingleOption]!],
        [FilterVariant.NumericRange, consumerFilters[FilterVariant.NumericRange]!]
    ]);

    const isRowSelectable = () => !isConsumersLoading;

    return {
        isConsumersLoading,
        isRowSelectable,
        getConsumers,
        downloadCsv,
        filterTypes,
        CellProps,
        FiltersProps,
        selectionModel,
        setSelectionModel
    };
}
